import { useEffect, useState } from 'react';
import { useCall } from './CallProvider';
import { canPickSpeaker, listDevices, savedDevice } from './devices';

/*
 * Три списка: микрофоны, камеры, динамики. Динамики — только где браузер
 * умеет их переключать. Открывается из шестерёнки в панели звонка.
 */

export function DeviceMenu({ onClose }: { onClose: () => void }) {
  const call = useCall();
  const [mics, setMics] = useState<MediaDeviceInfo[]>([]);
  const [cams, setCams] = useState<MediaDeviceInfo[]>([]);
  const [speakers, setSpeakers] = useState<MediaDeviceInfo[]>([]);

  useEffect(() => {
    listDevices()
      .then((d) => {
        setMics(d.mics);
        setCams(d.cams);
        setSpeakers(d.speakers);
      })
      .catch(() => {});
  }, []);

  const label = (d: MediaDeviceInfo, i: number, word: string) => d.label || `${word} ${i + 1}`;

  return (
    <div className="call-menu" role="menu">
      <label>
        <span>Микрофон</span>
        <select
          defaultValue={savedDevice('audioinput') ?? ''}
          onChange={(e) => void call.switchInput('audioinput', e.target.value)}
        >
          {mics.map((d, i) => (
            <option key={d.deviceId} value={d.deviceId}>{label(d, i, 'Микрофон')}</option>
          ))}
        </select>
      </label>
      {cams.length > 0 && (
        <label>
          <span>Камера</span>
          <select
            defaultValue={savedDevice('videoinput') ?? ''}
            onChange={(e) => void call.switchInput('videoinput', e.target.value)}
          >
            {cams.map((d, i) => (
              <option key={d.deviceId} value={d.deviceId}>{label(d, i, 'Камера')}</option>
            ))}
          </select>
        </label>
      )}
      {canPickSpeaker() && speakers.length > 0 && (
        <label>
          <span>Динамик</span>
          <select value={call.speakerId} onChange={(e) => call.switchSpeaker(e.target.value)}>
            <option value="">По умолчанию</option>
            {speakers.map((d, i) => (
              <option key={d.deviceId} value={d.deviceId}>{label(d, i, 'Динамик')}</option>
            ))}
          </select>
        </label>
      )}
      <button type="button" className="btn primary sm" onClick={onClose}>Готово</button>
    </div>
  );
}
